module.exports = require("chartjs-adapter-moment");